import { DEFAULT_BOX_SHADOW } from 'App/constants'
import React from 'react'

function TabCount({ title, total }) {
  return (
    <div
    className='member-count'
    style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#fff",
      minHeight: "130px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "8px",
      boxShadow: DEFAULT_BOX_SHADOW,
      position: "relative",
    }}>
    <div className=''>
      {" "}
      <p
        style={{
          position: "absolute",
          top: "10%",
          right: "5%",
          fontWeight: 600,
          fontSize: "14px",
          color: "#333",
        }}>
        {title}
      </p>
      <p
        style={{
          color: "#296218",
          fontSize: "2.5vw",
          fontWeight: 600,
          marginTop: "1.3rem",
        }}>
        {total}
      </p>
    </div>
  </div>
  )
}

export default TabCount